import { categoryModule } from './store/category'
import { StorefrontModule } from '@vue-storefront/core/lib/modules';
import { partnerModule } from './store/partner';

export const CatalogNextModule: StorefrontModule = function ({store}) {
  store.registerModule('category-next', categoryModule)
  store.registerModule('partner', partnerModule);
}
